import { createWorkOrderFinishedPage } from './report/BC8WorkOrderFinished/create';
import { createProductionPlanViewSlideDetailsPage } from './report/BC02productionPlan/viewSlideDetails/create';
import { createProductionTimePage } from './report/BCproductionTime/create';
import { createProductionActivitiesPage } from './report/BC09productionActivities/create';
import { createMachineUptimePage } from './report/BC05machineUptime/create';
import { createMachineBreakdownTimePage } from './report/BC06machineBreakdownTime/create';
import { createPivotTablePage } from './report/BC04quantityAndProductivity/pivotTable/create';
import { createDiagramMachinePage } from './report/BC01machineStatus/diagram/create';
import { createMatchCardCommandPage } from './matchCardCommand/create';
import { createStuckWarningPage } from './report/BC03stuckWarning/create';
import { createCheckStateMarketingPage } from './report/BC11checkStateMarketing/create';
import { createQnPPage } from './report/BC04quantityAndProductivity/create';
import { createProductionPlanPage } from './report/BC02productionPlan/create';
import { createProductRoutingPage } from './productRouting/create';
import { IServices } from 'services/services';
import { LayoutHOC } from 'base/ui/layout/layout';
import { createHomePage } from './home/create';
import { createLoginPage } from './login/create';
import { createTestTargetPage } from './testTarget/create';
import { createAddTestTargetPage } from './testTarget/AddTestTarget/create';
import { createMachineStatusPage } from './report/BC01machineStatus/create';
import { createWorkOrderPage } from './workOrder/create';
import { createAddSerialPage } from './workOrder/addSerial/create';
import { createProductPage } from './product/create';
import { createProductDeTailPage } from './product/productDetail/create';
import { createWODetailPage } from './workOrder/workOrderDetails/create';
import { createEditProductPage } from './product/editProduct/create';
import { createMatchCardCommandDetailPage } from './matchCardCommand/matchCardCommandDetail/create';
import { createCompletionRatePage } from './report/BC07completionRate/create';
import { createProductionPlanViewDetailsPage } from './report/BC02productionPlan/viewDetails/create';
import { createHistoryReceivePage } from './historyReceive/create';
import { createHistoryReceiveDetailPage } from './historyReceive/historyReceiveDetail/create';
import { createCheckSMDetailPage } from './report/BC11checkStateMarketing/Detail/create';
import { createStockReceivingPage } from './WareHouse/create';
import { createStockRecevingDetailPage } from './WareHouse/StockRecevingDetail/create';
import { createStockReceivingAddPage } from './WareHouse/StockRecevingAdd/create';
import { createCatalogTypePage } from './rawData/CatalogType/create';
import { createAddCatalog } from './rawData/CatalogType/AddCatalog/create';
import { createAddRoutingOrTransferPage } from './rawData/RoutingOrTransfer/Add/create';
import { createUpdateRoutingOrTransferPage } from './rawData/RoutingOrTransfer/Update/create';
import { createRoutingOrTransferPage } from './rawData/RoutingOrTransfer/create';
import { createProductionPlanningReportPage } from './workOrder/productionPlanningReport/create';
import { createStyleCategoryPage } from './StyleCategory/create';

export function createPages(layoutHOC: LayoutHOC, services: IServices) {
  return {
    HomePage: createHomePage(layoutHOC),
    LoginPage: createLoginPage(layoutHOC),
    TestTargetPage: createTestTargetPage(layoutHOC),
    StyleCategoryPage: createStyleCategoryPage(layoutHOC),
    MachineStatusPage: createMachineStatusPage(layoutHOC),
    AddTestTargetPage: createAddTestTargetPage(layoutHOC),
    WorkOrderPage: createWorkOrderPage(layoutHOC),
    AddSerialPage: createAddSerialPage(layoutHOC),
    ProductDetailPage: createProductDeTailPage(layoutHOC),
    ProductPage: createProductPage(layoutHOC),
    ProductionPlanPage: createProductionPlanPage(layoutHOC),
    ProductionPlanDetailsPage: createProductionPlanViewDetailsPage(layoutHOC),
    ProductionPlanSlideDetailsPage: createProductionPlanViewSlideDetailsPage(layoutHOC),
    QnPPage: createQnPPage(layoutHOC),
    CompletionRatePage: createCompletionRatePage(layoutHOC),
    MachineBreakdownTimePage: createMachineBreakdownTimePage(layoutHOC),
    MachineUptimePage: createMachineUptimePage(layoutHOC),
    ProductionActivitiesPage: createProductionActivitiesPage(layoutHOC),
    ProductionTimePage: createProductionTimePage(layoutHOC),
    QnPPivoteTablePage: createPivotTablePage(layoutHOC),
    DiagramMachinePage: createDiagramMachinePage(layoutHOC),
    CheckStatusMarketingPage: createCheckStateMarketingPage(layoutHOC),
    StuckWarningPage: createStuckWarningPage(layoutHOC),
    WorkOrderFinishedPage: createWorkOrderFinishedPage(layoutHOC),
    WODetailPage: createWODetailPage(layoutHOC),
    EditProductPage: createEditProductPage(layoutHOC),
    ProductRoutingPage: createProductRoutingPage(layoutHOC),
    MatchCardCommandPage: createMatchCardCommandPage(layoutHOC),
    MatchCardCommandDetailPage: createMatchCardCommandDetailPage(layoutHOC),
    HistoryReceivePage: createHistoryReceivePage(layoutHOC),
    HistoryReceiveDetailPage: createHistoryReceiveDetailPage(layoutHOC),
    CheckSMDetailPage: createCheckSMDetailPage(layoutHOC),
    ProductionPlanningPage: createProductionPlanningReportPage(layoutHOC),
    // Nhập kho khuôn
    StockReceivingPage: createStockReceivingPage(layoutHOC),
    //Trang detail ở nhập kho khuôn
    StockRecevingDetailPage: createStockRecevingDetailPage(layoutHOC),
    // Thêm mới ở nhập kho khuôn
    StockReceivingAddPage: createStockReceivingAddPage(layoutHOC),
    // Dữ liệu nền
    // Loại danh mục dùng chung
    CatalogTypePage: createCatalogTypePage(layoutHOC),
    //Add Catalog
    AddCatalogPage: createAddCatalog(layoutHOC),

    // Routing or transfer
    RoutingOrTransferPage: createRoutingOrTransferPage(layoutHOC),
    AddRoutingOrTransferPage: createAddRoutingOrTransferPage(layoutHOC),
    UpdateRoutingOrTransferPage: createUpdateRoutingOrTransferPage(layoutHOC),
  };
}
